import React from 'react';
import { useCJSeances } from 'containers/CahierJournal/queries/useCJSeances';
import 'twin.macro';
import { format } from 'utils/time/format';
import { DayPreview } from './DayPreview';
import { ClassroomsOrg } from 'types/school';
import { EventsLoader } from './EventsLoader';
import { useTranslation } from 'react-i18next';
import { useClassroomsCopyEvents } from './useClassroomsCopyEvents';

interface Props {
  schoolyearId?: string;
  schoolId?: string;
  date: Date;
  classroomsOrg: ClassroomsOrg;
}

export function EventsPreview(props: Props) {
  const { schoolId, schoolyearId } = props;
  const { t } = useTranslation(['common', 'cahierJournal']);
  const { data, isLoading, isFetching } = useCJSeances({
    from: format(props.date, 'fr-FR'),
    to: format(props.date, 'fr-FR'),
    schoolId,
    schoolyearId,
  });
  const classrooms = useClassroomsCopyEvents({
    schoolId,
    schoolyearId,
  });
  if (isLoading || isFetching || !data) {
    return <EventsLoader />;
  }
  if ((data || []).length === 0) {
    return (
      <div tw="text-lg text-center">
        {t('cahierJournal:copyEventsToAnotherDayModal.noSeanceOnThatDay')}
      </div>
    );
  }
  return (
    <DayPreview
      events={data || []}
      classrooms={classrooms || []}
      allClassrooms={classrooms || []}
      classroomsOrg={props.classroomsOrg}
      day={props.date}
    />
  );
}
